import VueAnalytics from '@ndrive/vue-ua'
import Package from '../../package'
import router from '../router'

export default {
  install: function (Vue, env) {
    if (!env.GOOGLE_ANALYTICS_TRACKING_ID) {
      return
    }
    Vue.use(VueAnalytics, {
      appName: Package.name,
      appVersion: Package.version,
      trackingId: env.GOOGLE_ANALYTICS_TRACKING_ID,
      debug: env.GOOGLE_ANALYTICS_DEBUG,
      vueRouter: router
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/analytics.js